/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {LicenseNotes} from '../models/LicenseNotes';

export interface SaveLicenseNotes$Request {
    licenseId: number;
    licenseNotes: LicenseNotes;
}

export interface SaveLicenseNotes$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveLicenseNotesRequest = createAction<PayloadData<void, SaveLicenseNotes$Request>>('SAVE_LICENSE_NOTES__SAVE_LICENSE_NOTES__REQUEST');
export const saveLicenseNotesSuccess = createAction<PayloadData<void, SaveLicenseNotes$Request>>('SAVE_LICENSE_NOTES__SAVE_LICENSE_NOTES__SUCCESS');
export const saveLicenseNotesFailure = createAction<PayloadData<Error, SaveLicenseNotes$Request, true>>('SAVE_LICENSE_NOTES__SAVE_LICENSE_NOTES__FAILURE');

export const saveLicenseNotesActions = [
    saveLicenseNotesRequest,
    saveLicenseNotesSuccess,
    saveLicenseNotesFailure
] as const;

/**
 * @param {number} meta.licenseId
 * @param {LicenseNotes} meta.licenseNotes
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveLicenseNotes = (meta: SaveLicenseNotes$Request, config?: SaveLicenseNotes$Config) => {
    return {
        CALL_API: {
            types: saveLicenseNotesActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/licenses/${meta.licenseId}/notes`,
            TRANSPORT_REQUEST_BODY: meta.licenseNotes,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

